// @flow

import React from "react";
import Video from "app/models/Video";
import ImageHelper from "app/util/ImageHelper";

import "./VideoBeforePlayOverlay.scss";

type Props = {
    video: Video,
    onClick: Function
};

export default class VideoBeforePlayOverlay extends React.PureComponent<Props> {
    render() {
        const video = this.props.video;
        const thumbnail = ImageHelper.makeUrl(video.source_thumbnail);

        return (
            <div className="VideoBeforePlayOverlay" onClick={this.props.onClick}>
                <div
                    className="VideoBeforePlayOverlay__background"
                    style={{ backgroundImage: `url(${thumbnail})` }}
                />


                <div className="VideoBeforePlayOverlay__actions">
                    <i className="fa fa-4x fa-play" aria-hidden="true">                        
                    </i>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoBeforePlayOverlay/VideoBeforePlayOverlay.js